import * as Yup from 'yup';
import { AuditingEntity, DictCountry, Qualification } from '@models';
import { SkauType } from '@enums';

export function useValidationSchema() {
  return Yup.object<Qualification>().shape({
    number: Yup.string()
      .nullable()
      .required()
      .matches(/^[a-zA-Z0-9]*$/, 'Povolené znaky: a-z, A-Z, 0-9'),
    skauType: Yup.mixed<SkauType>().nullable().required(),
    origin: Yup.object().shape({
      country: Yup.mixed<DictCountry>().nullable().required(),
      institution: Yup.string().nullable().required(),
    }),
    subject: Yup.mixed<AuditingEntity>().nullable().required(),
  });
}
